export default "__VITE_ASSET__7eba1bbf__"